
import React from 'react';
import "../../reusableComponents/tab/tab.scss"
const TabComponent = ({ tabs, activeTab, handleTabClick }) => {
    return (
        <div className='d-flex align-items-center'>
            {tabs.map((tab, index) => (
                <div
                    key={index}
                    className={`tab ${activeTab === tab.key ? 'active' : 'inactive'}`}
                    onClick={() => handleTabClick(tab.key)}
                >
                    {tab.label}
                </div>
            ))}
        </div>
    );
};

export default TabComponent;
